<template>
    <div class="tp_box" style="background:#f2f2f2;min-height: 100%;">
        <!-- <el-container> -->
            <!-- <el-main style="margin:0 50px;"> -->
                <!-- <el-row> -->
                    <!-- <el-col :sm="1" :md="2" :lg="2" :xl="3"><div style="min-height:30px;"></div></el-col> -->
                    <!-- <el-col :sm="15" :md="14" :lg="14" :xl="14"> -->
                    <!-- <el-col :sm="15" :md="15" :lg="15" :xl="15" class="clearfix" style="box-sizing: border-box;float: none;margin: 0 auto 30px;"> -->
                    <div class="warp_container w_padding">
                        <!-- 菜单 -->
                        <div class="course_type" v-if="getCategoryData.length">
                            <!-- 一级菜单 -->
                            <!-- <span v-for="(val,key) in getCategoryData" :key="key" @click="activeCgId(key)" :class="{'activeColor':getCategoryId===val.id&&show}">{{val.name}}</span> -->
                            <!-- 二级菜单 -->
                            <!-- <div class="tab_content" ref="tab_content" v-if="show">
                                <template v-if="childId!=null&&getCategoryData[childId].children.length>0">
                                    <span class="chlid_tab_txt" v-for="(val,item) in getCategoryData[childId].children" :key="item" @click="CgChlidId(item)" :class="{'active_chlid':val.id===chlidCgId}">
                                        {{val.name}}
                                    </span>
                                </template>
                            </div> -->
                            <div class="course_type">
                                <div class="cat_item" :class="{'cat_active':subject_id==val.id}" v-for="(val,key) in getCategoryData" @click="catActive(val)" :key="key">{{val.name}}</div>
                            </div>
                        </div>
                        <!-- 菜单结束 -->
                        <!-- 试卷列表 -->
                        <!-- <el-tabs v-if="subjectType.length" v-model="activeName" @tab-click="handleClick" class="tp_tab" style="background:#fff;padding:30px;">
                            <el-tab-pane v-for="(v,k) in subjectType" :key="k" :label="v.name" :name="v.code">
                                <template v-if="listData.length>0">
                                    <div class="tp_list" v-for="(value,key) in listData" :key="key">
                                        <div class="lsit_item cursor" @click="doExam(value,activeName+key)">
                                            <div class="lsit_item_txt">
                                                <div class="dot" :class="{'no_auh':value.auth==false}"></div>
                                                <span class="tp_l_txt" :class="{'no_auh_grey':value.auth==false}">{{value.testpaper_name}}</span>
                                            </div>
                                            <img v-if="userInfo" :class="{'o_img':value.auth,'s_img':!value.auth}" :src="value.auth?require('../assets/open.png'):require('../assets/close.png')" alt="">
                                        </div>
                                        <a class="list_blank" :ref="activeName+key" href="" target="_blank"></a>
                                    </div>

                                </template>
                                <div v-if="subEmpty" class="no_data_txt">
                                    <img class="empty_img" src="../assets/empty.png" alt="">
                                    <div class="empty_txt_top">暂无相关习题</div>
                                </div>
                            </el-tab-pane>
                        </el-tabs> -->
                        <div class="list_box" v-if="subjectType.length">
                            <div class="tbs_box">
                                <div v-if="nowLen>0" style="cursor: pointer;" @click="prevNav"><img src="../assets/prev_type.png" alt=""></div>
                                <div class="tbs_nav">
                                    <div class="tbs_nav_item" v-for="(v,k) in subjectType" :key="k">
                                        <div class="tbs_nav_item_sub" @click="handleClick(v)">
                                            <div class="tbs_nav_item_txt" :class="{'tbs_nav_item_active':v.code==activeName}">{{v.name}}</div>
                                            <div class="tbs_nav_line" v-if="v.code==activeName"></div>
                                        </div>
                                    </div>

                                </div>
                                <div class="right_tbs_btn" v-if="allLen>0&&allLen!=nowLen" @click="nextNav">
                                    <div style="white-space:nowrap;marginRight: 5px;">更多</div>
                                    <img src="../assets/next_type.png" alt="">
                                </div>
                            </div>

                            <div class="tp_list" v-for="(value,key) in listData" :key="key">
                                <div class="lsit_item cursor" @click="doExam(value,activeName+key)">
                                    <div class="lsit_item_txt">
                                        <div class="dot"></div>
                                        <span class="tp_l_txt">{{value.testpaper_name}}</span>
                                    </div>
                                    <img v-if="userInfo" :class="{'o_img':value.auth,'s_img':!value.auth}" :src="value.auth?require('../assets/open.png'):require('../assets/close.png')" alt="">
                                </div>
                                <a class="list_blank" :ref="activeName+key" href="" target="_blank"></a>
                            </div>
                        </div>
                        <!-- 试卷列表结束 -->
                    </div>


        <div class="list_hit" v-if="isHit" @click="loadMorePaper">
          <i class="el-icon-loading" v-if="testpaperLoadStatus == 1"></i>
          <p v-else>{{hitTxt}}</p>
        </div>
        <div class="no_nav_data" v-if="empty">
            <img class="wrap_empty_img" src="../assets/tp_empty.png" alt="">
            <div class="wrap_empty_txt_top">暂无相关习题</div>
        </div>
        <img v-if="isScroll" class="scllotop_img" src="../assets/scllotop.png" alt="" @click="scllotop">
        <div class="blank"></div>
        <div class="toast_box" v-if="isToast">没有做题权限</div>
        <div class="popup" v-if="isPopup">
            <div class="msk" @click.stop="closePop"></div>
            <div class="pop_cont">
                <div class="pop_cont_sub">
                    <img class="close_icon" src="../assets/pop_close.png" alt="" @click.stop="closePop">
                    <div class="pop_title">请选择做题模式 </div>
                    <div class="pop_btn_box">
                        <div class="pop_btn_left cursor" @click.stop="tpType(1)">考试模式</div>
                        <div class="pop_btn_right cursor" @click.stop="tpType(2)">背题模式</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import store from '../store'
    export default {
        name: 'TestpaperList',
        data () {
            return {
                activeName: 'testa',
                listData: [],
                getCategoryData: [],
                allTypeData: null,
                itemType: [],
                subjectType: [],
                subject_id: null,
                type_code: null,
                currentPage: 1,  //默认选中页
                currentPage2: 1,
                currentPage3: 1,
                currentPage4: 1,
                total: null,  //总数据条数
                page_size: '',  //每页显示条数
                show:false,
                prev:null,
                next:null,
                childId:null,
                chlidCgId: null,
                prevChlidChick: null,
                nextChlidChick: null,
                page: 1,
                lastPage: 0,
                empty: false,
                subEmpty: false,
                isScroll: false,
                timer: null,
                isHit: false,
                hitTxt: '',
                isToast: false,
                toastTimer: null,
                allLen: 0,
                nowLen: 0,
                isPopup: false,
                activeTP: {},
                testpaperLoadStatus: 0, // 试卷加载状态
            }
        },
        computed: {
            ...mapState([
                "userInfo"
            ])
        },

        methods: {
            closePop() {
                this.isPopup=false
            },
            // 切换类型
            handleClick(tab) {
                // console.log(tab,'tab');
                // tab.name   //type_code
                this.activeName=tab.code;
                this.page=1
                var data={
                    page: this.page,
                    area_code: localStorage.getItem("area_code"),
                    category_id: localStorage.getItem("cate_id"),
                    testpaper_type: this.activeName,
                    subject_id: this.subject_id,
                    pagesize: 10
                }
                this.getTPList(data)
            },
            prevNav() {
                if(this.nowLen>0){
                    this.nowLen=this.nowLen-1
                    this.subjectType=this.itemType[this.nowLen]
                }
            },
            nextNav(){
                if(this.nowLen!=this.allLen){
                    this.nowLen=this.nowLen+1
                    this.subjectType=this.itemType[this.nowLen]
                }
            },
            // 获取试卷列表数据
            getTPList(data) {
              this.testpaperLoadStatus = 1
                this.$http.get(this.filterUrl('/api/v2/Testpaper/getTestpaper'), {
                    headers:{
                        'token': localStorage.getItem('token') ? localStorage.getItem('token'):''
                    },
                    params: data
                })
                .then((res) => {
                    if(res.data.code===1){
                        var d= res.data.data,arr=[]
                        if(this.page==1&&d.length==0){
                            // this.subEmpty=true
                            this.listData=d
                        }else{
                            // this.subEmpty=false
                            if(d.length==0){
                                this.isHit=true
                                this.hitTxt="我也是有底线的"
                            }
                        }
                        this.lastPage=d.length
                        if(d.length>0) {
                            for(var i=0;i<d.length;i++){
                                arr.push(d[i].testpaper_id)
                            }
                            this.testpaperAuth(arr,res.data.data)
                        }
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }

                }).catch((err) => {
                    this.$message.error(err);
                }).finally(() => {
                  this.testpaperLoadStatus = 0 // 加载结束
                })
            },
            testpaperAuth(data,d) {
                this.$http.post(this.filterUrl('/api/v2/Testpaper/checkTestpaperAuth'), {testpaper_id:data},
                    {
                    headers: {
                        token:
                            localStorage.getItem("token") !== null
                            ? localStorage.getItem("token")
                            : ""
                    }
                })
                .then((res) => {
                    if(res.data.code===1){
                        var arr=res.data.data
                        for(var i=0;i<arr.length;i++){
                            for(var j=0;j<d.length;j++){
                                if(arr[i].testpaper_id==d[j].testpaper_id){
                                    d[j].auth=arr[i].auth
                                }
                            }
                        }
                        if(this.page==1){
                            this.listData=d
                        }else{
                            this.listData=this.listData.concat(d)
                        }
                        if(d.length==10){
                            this.isHit=true
                            this.hitTxt="下拉加载更多"
                        }else if(this.page>1&&d.length<10){
                            this.isHit=true
                            this.hitTxt="我也是有底线的"
                        }else{
                             this.isHit=false
                        }
                        // console.log(this.listData,9999)
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }else if(res.data.code===10001){
                        store.commit('setDialogLogin',true);
                    }
                })
                .catch((err) => {
                    this.$message.error(err);
                })
            },
            getCategory(callback) {  //获取试卷分类
                this.$http.get('/api/v2/subject/getSubjectsByCateId', {
                   params:{
                       id: localStorage.getItem("cate_id")
                   }
                })
                .then((res) => {
                    console.log(res.data,"一级获取试卷分类")
                    if(res.data.code==0){
                        this.getCategoryData=[]
                        this.subjectType=[]
                        this.empty=true
                        return false
                    }
                    if(res.data.data.length==0){
                        this.empty=true
                    }
                    // this.getCategoryData=res.data.data
                    if(callback&&res.data.data.length){
                        callback(res.data.data)
                    }
                })
                .catch((err) => {
                    console.log(err,"获取试卷分类8989")
                    // this.$message.error(err);
                })
            },
            getValidTestpaper(array,subject_id) {
                this.$http.get('/api/v2/testpaper/getTestPaperTypeOfExistTestPaperPC', {
                    params:{
                            area_code: localStorage.getItem("area_code"),
                            subject_id: subject_id
                        }
                    })
                    .then((res) => {
                    if(res.data.code===1){
                        this.allTypeData=res.data.data
                        var len=Object.keys(res.data.data),arr=[],itemType,result = [];
                        if(len.length){
                            this.empty=false
                        }else{
                            this.empty=true
                        }
                        for(var k in this.allTypeData){
                            for(var i=0;i<array.length;i++){
                                if(k==array[i].id){
                                    arr.push(array[i])
                                }
                            }
                        }

                        this.getCategoryData=arr
                        if(this.$route.query.subject_id) {
                            this.subject_id=this.$route.query.subject_id
                        }else{
                            this.subject_id=this.getCategoryData[0].id
                        }

                        itemType=this.allTypeData[this.subject_id]
                        for(var i=0,len=itemType.length;i<len;i+=6){
                            result.push(itemType.slice(i,i+6));
                        }
                        this.itemType=result
                        this.allLen=this.itemType.length-1

                        if(this.$route.query.type_id){

                            this.activeName=this.$route.query.type_id
                            for(var i=0;i<this.itemType.length;i++){
                                this.itemType[i].forEach((itm,ky)=>{
                                    if(itm.code==this.activeName){
                                        this.subjectType=this.itemType[i]
                                        this.nowLen=i
                                    }
                                })
                            }
                        }else{
                            this.nowLen=0
                            this.subjectType=this.itemType[0]
                            this.activeName=this.subjectType[0].code
                        }
                        console.log(this.getCategoryData,9090)
                        this.page=1
                        var data={
                            page: this.page,
                            area_code: localStorage.getItem("area_code"),
                            category_id: localStorage.getItem("cate_id"),
                            testpaper_type: this.activeName,
                            subject_id: this.subject_id,
                            pagesize: 10
                        }
                        this.getTPList(data)
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }

                }).catch((err) => {
                    this.$message.error(err);
                })
            },
            filterUrl (url){
                return url.indexOf('?') !== -1 ? `${url}&time=${new Date().getTime()}` : `${url}?time=${new Date().getTime()}`
            },
            tpType(e) {
                if(e==1){
                    var target=this.$refs[this.activeTP.name][0]
                    target.setAttribute('href', window.location.origin+'/doTopic?id='+this.activeTP.data.testpaper_id+'&testpaper_name='+this.activeTP.data.testpaper_name)
                    target.click()
                }else{
                    var target=this.$refs[this.activeTP.name][0]
                    target.setAttribute('href', window.location.origin+'/lookTopic?id='+this.activeTP.data.testpaper_id+'&testpaper_name='+this.activeTP.data.testpaper_name)
                    target.click()
                }
                this.closePop()
            },
            doExam(val,name) {
                console.log(val,name,789)
                if(this.userInfo){
                    if(val.auth){
                        if(val.do_method.length==0){
                            var target=this.$refs[name][0]
                            target.setAttribute('href', window.location.origin+'/doTopic?id='+val.testpaper_id+'&testpaper_name='+val.testpaper_name)
                            target.click()
                        }else if(val.do_method.length==1){
                            if(val.do_method[0]==1){
                                var target=this.$refs[name][0]
                                target.setAttribute('href', window.location.origin+'/doTopic?id='+val.testpaper_id+'&testpaper_name='+val.testpaper_name)
                                target.click()
                            }else{
                                var target=this.$refs[name][0]
                                target.setAttribute('href', window.location.origin+'/lookTopic?id='+val.testpaper_id+'&testpaper_name='+val.testpaper_name)
                                target.click()
                            }
                        }else{
                            this.activeTP['name']=name
                            this.activeTP['data']=val
                            this.isPopup=true
                        }
                    }else{
                        clearTimeout(this.toastTimer)
                        this.isToast=true
                        this.toastTimer=setTimeout(()=>{
                            this.isToast=false
                        },2000)
                    }
                }else{
                    store.commit('setDialogLogin',true);
                }
            },
            doTPlink(val) {
                if(localStorage.getItem('token')){
                    this.$router.push({ name: 'dotopic', query: { id: val.testpaper_id, testpaper_name:val.testpaper_name, time:val.testpaper_limited_time} })
                }else{
                    store.commit('setDialogLogin',true);
                }

            },
            currentPageData(page) { //选中列表数据

                var data={};
                if(this.type_code){
                    data.type_code=this.type_code
                }
                if(this.chlidCgId){
                    data.testpaper_category_id=this.chlidCgId
                }
                // if(JSON.stringify(data) == "{}"){}

                this.$http.get('/api/v2/Testpaper/getTestpaper?page='+page||'',
                    {params: data}
                )
                .then((res) => {

                    if(res.data.code===1){
                        this.listData=res.data.data.data
                        this.total=res.data.data.total
                        this.page_size=res.data.data.per_page
                    }else if(res.data.code===0){
                        this.$message.error(res.data.msg);
                    }

                }).catch((err) => {
                    this.$message.error(err);
                })
            },
            // 切换分类
            catActive(e) {
                console.log(e,789456)
                if(e.id!=this.subject_id){
                    this.subject_id=e.id

                    var itemType=this.allTypeData[this.subject_id],result=[];
                    for(var i=0,len=itemType.length;i<len;i+=6){
                        result.push(itemType.slice(i,i+6));
                    }
                    this.itemType=result
                    this.allLen=this.itemType.length-1
                    this.nowLen=0
                    this.subjectType=this.itemType[0]
                    this.activeName=this.subjectType[0].code
                    this.page=1
                    var data={
                        page: this.page,
                        area_code: localStorage.getItem("area_code"),
                        category_id: localStorage.getItem("cate_id"),
                        testpaper_type: this.activeName,
                        subject_id: this.subject_id,
                        pagesize: 10
                    }
                    this.getTPList(data)
                }


            },
            activeCgId(index){ //分类
                this.childId=index; //存一级分类的下标
                this.subject_id=this.getCategoryData[index].id; //存一级分类id
                //上一次与下次点击区分
                // if(this.prev==null&&this.next==null){
                //     this.prev=this.getCategoryData[index].id;
                // }else if(this.prev && this.next==null){
                //     this.next=this.getCategoryData[index].id;
                // }else if(this.prev && this.next){
                //     this.prev=this.next;
                //     this.next=this.getCategoryData[index].id;
                // }
                //区分点击是不是同一分类
                // if(this.prev === this.next && this.prev){
                //     this.show=!this.show;
                // }else if(this.prev !== this.next){
                //     this.show=true
                // }

            },
            CgChlidId(id){ //选二级分类事件
                this.chlidCgId=this.getCategoryData[this.childId].children[id].id; //存二级分类id

                if(this.prevChlidChick==null&&this.nextChlidChick==null){
                    this.prevChlidChick=this.getCategoryData[this.childId].children[id].id;
                }else if(this.prevChlidChick && this.nextChlidChick==null){
                    this.nextChlidChick=this.getCategoryData[this.childId].children[id].id;
                }else if(this.prevChlidChick && this.nextChlidChick){
                    this.prevChlidChick=this.nextChlidChick;
                    this.nextChlidChick=this.getCategoryData[this.childId].children[id].id;
                }

                if(this.prevChlidChick !== this.nextChlidChick){
                    this.type_code==='zj' ? this.currentPage=1 :
                    this.type_code==='zt' ? this.currentPage2=1 :
                    this.type_code==='mn' ? this.currentPage3=1 :
                    this.type_code==='zx' ? this.currentPage4=1 : this.currentPage=1
                }

                if(this.type_code){
                    this.type_code==='zj' && this.currentPageData(this.currentPage)
                    this.type_code==='zt' && this.currentPageData(this.currentPage2)
                    this.type_code==='mn' && this.currentPageData(this.currentPage3)
                    this.type_code==='zx' && this.currentPageData(this.currentPage4)
                }else{
                    this.currentPageData(this.currentPage)
                }
            },
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                // console.log(`当前页: ${val}`);
                this.currentPageData(val)
                // console.log(this.currentPage)
            },
            scllotop() {
                let returnEle = document.querySelector(".tp_box");
                if(!!returnEle){
                    document.documentElement.scrollTop = returnEle.offsetTop
                }
            },
            // 监听页面触底
            scrollEvent(e){
                clearTimeout(this.timer)
                this.isScroll=true
                this.timer=setTimeout(()=>{
                    this.isScroll=false
                },2000)
                 // console.log("触发滚动")
                console.log(document.documentElement.scrollTop + document.documentElement.clientHeight >= document.body.scrollHeight,"滚动到底部",this.lastPage)
                if(document.documentElement.scrollTop + document.documentElement.clientHeight >= document.body.scrollHeight&&this.lastPage==10){
                    this.loadMorePaper()
                }
            },
            // 点击底部加载提示区域
            loadMorePaper() {
              // 加载完成了
              if(this.lastPage < 10) {
                return
              }
              // 加载是否进行中
              if(this.testpaperLoadStatus == 1) {
                return
              }
              // 加载数据
              this.page=this.page+1
              var data={
                  page: this.page,
                  area_code: localStorage.getItem("area_code"),
                  category_id: localStorage.getItem("cate_id"),
                  testpaper_type: this.activeName,
                  subject_id: this.subject_id,
                  pagesize: 10
              }
              this.getTPList(data)
            }
        },

        created() {
            // console.log(this.$route.query,"query")
            this.$changeTitle();
            // this.getTPList();
            this.getCategory((e)=>{
                var str=''
                e.forEach((item,k)=>{
                    if(k==0){
                        str=str+item.id
                    }else{
                        str=str+','+item.id
                    }
                })
                this.getValidTestpaper(e,str)
            })
            //
            store.commit('setNav',2);
        },
        mounted() {
            window.addEventListener('scroll',this.scrollEvent,false)
        },
        destroyed(){
            window.removeEventListener('scroll', this.scrollEvent);
        }
    }
</script>

<style scoped>
    /* html,body,#app{
        width: 100%;
        height: 100%;
    } */
    .w_padding{
        padding-top: 30px;
    }
    .course_type{
        background: #ffffff;
        /* padding: 20px; */
        /* margin: 30px 0; */
        margin-bottom: 30px;
        border-radius: 20px;
        width: 100%;
        padding: 30px 0 12px 40px;
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
    }
    /* .course_type>span{
        display: inline-block;
        padding: 10px;
    } */
    /* .course_type span:hover{
        color: #3aac58;
    } */
    .cat_item{
        padding: 12px 0;
        margin-bottom: 18px;
        margin-right: 50px;
        border: 1px solid #ffffff;
        cursor: pointer;
    }
    .cat_item:last-child {
        margin-right: 40px;
        /* margin-bottom: 42px; */
    }
    .cat_active{
        /* position: relative;
        z-index: 2; */
        padding: 12px 18px;
        background: #00C590;
        border-radius: 100px;
        color: #ffffff;
    }
    .list_box{
        border-radius: 20px;
        padding: 22px 40px 30px;
        background: #ffffff;
        min-height: 510px;
        box-sizing: border-box;
    }
    .tbs_box{
        height: 41px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border-bottom: 1px solid #E7E7E7;
        box-sizing: border-box;
        margin-bottom: 20px;
    }
    .right_tbs_btn{
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #00C590;
        cursor: pointer;
    }
    .tbs_nav{
        width: 100%;
        height: 40px;
        padding: 0 20px;
        display: flex;
        box-sizing: border-box;
    }
    .tbs_nav_item{
        width: 16%;
        height: 40px;
    }
    .tbs_nav_item_sub{
        position: relative;
        height: 40px;
        display: inline-block;
        cursor: pointer;
    }
    .tbs_nav_item_txt{
        height: 40px;
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #333;
    }
    .tbs_nav_item_active{
        font-size: 18px;
        color: #00C590;
        font-weight: bold;
    }
    .tbs_nav_line{
        position: absolute;
        display: inline-block;
        width: 100%;
        height: 5px;
        background: #00C590;
        border-radius: 5px;
        left: 0;
        bottom: 0;
    }
    .tab_content{
        width: 100%;
        min-height: 20px;
        padding: 30px;
        background: #bcecc949;
        box-sizing: border-box;
        /* display: none; */
    }
    .chlid_tab_txt{
        padding: 0 10px 10px 0;
    }
    .active_chlid{
        color: #3aac58;
    }
    .el-tabs__header .el-tabs__nav-wrap::after {
        background: #ffffff !important;
    }
    .lsit_item{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        line-height: 50px;
        font-size: 16px;
    }
    .lsit_item:hover{
        background: #f0f0f0;
        color: #00c590;
    }
    .lsit_item_txt{
        display: flex;
        align-items: center;
        box-sizing: border-box;
        max-width: 90%;
    }
    .tp_l_txt{
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    }
    .list_blank{
        position: absolute;
        left: 0;
        top: 0;
    }
    .right_nav{
        background: #fff;
        height: 60px;
    }
    .right_nav a{
        display: inline-block;
        width: 49%;
        text-align: center;
    }
    .no_data_txt{
        font-size: 16px;
        text-align: center;
        padding-top: 70px;
    }
    /* 分页样式 */
    .pageination_box{
        width: 100%;
        position: relative;
        height: 35px;
        margin-top: 20px;
    }
    .activeColor{
        color: #ffffff;
        background: #3aac58;
    }

    .dot{
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: #00C590;
        margin-right: 10px;
        position: relative;
    }
    .no_auh{
        background: #CCCCCC;
    }
    .no_auh_grey{
        color: #999999;
    }
    .dot:before{
        top: 50%;
        left: 50%;
        content: '';
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #ffffff;
        position: absolute;
        transform: translate(-50%,-50%);
    }

    .o_img{
        width: 20px;
        height: 20px;
    }
    .s_img{
        width: 20px;
        height: 22px;
    }
    .empty_img{
        width: 151px;
        height: 160px;
    }
    .wrap_empty_img{
        width: 360px;
        height: 265px;
    }
    .empty_txt_top{
        margin-top: 20px;
    }
    .wrap_empty_txt_top{
        margin-top: 34px;
    }
    .no_nav_data{
        padding-top: 150px;
        font-size: 16px;
        text-align: center;
    }
    .scllotop_img{
        width: 31px;
        height: 31px;
        position: fixed;
        bottom: 200px;
        right: 200px;
    }
    .blank{
        width: 100%;
        height: 20px;
    }
    .list_hit{
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 10px;
        font-size: 14px;
        color: #999999;
        cursor: pointer;
        height: 32px;
        line-height: 32px;
        text-align: center;
    }
    .toast_box{
        padding: 10px 20px;
        font-size: 16px;
        background: rgba(0, 0, 0, .2);
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        border-radius: 10px;
        color: #999;
        z-index: 888;
    }
    .popup{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
    }
    .msk{
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .5);
        position: absolute;
        top: 0;
        left: 0;
    }
    .pop_cont{
        width: 400px;
        height: 280px;
        background: #FFFFFF;
        border-radius: 20px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
    }
    .pop_cont_sub{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .close_icon{
        width: 20px;
        height: 20px;
        position: absolute;
        right: 20px;
        top: 20px;
    }
    .pop_title{
        padding-top: 80px;
        width: 100%;
        text-align: center;
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        font-family: Microsoft YaHei;
    }
    .pop_btn_box{
        padding: 60px 40px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .pop_btn_left,.pop_btn_right{
        width: 140px;
        height: 50px;
        background: #00C590;
        border-radius: 10px;
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
<style>
    /* 分页样式 */
    .pageination_warp{
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        display: inline-block;
    }
    /* 切换 */
    .tp_tab .el-tabs__active-bar{
        background-color: #3aac58;
    }
    .tp_tab .el-tabs__item.is-active,.tp_tab .el-tabs__item:hover{
        color: #3aac58;
    }
    .tp_tab .el-tabs__item{
        font-size: 20px;
        font-weight: 300;
        padding-bottom: 10px;
        /* line-height: 0; */
    }
    /* 分页省略号bug */
    .tp_tab .el-pager .more:before{
        line-height: normal;
    }
    /* .tp_tab .el-tabs__item:hover{
        color: aquamarine;
    } */
</style>



// WEBPACK FOOTER //
// src/page/TestpaperList.vue